export default __webpack_public_path__ + "b2853b457cafbcf1d6e39b38b404598c.png";